import { useState, useEffect } from 'preact/hooks';
import useVendor from './useVendor';
import { vendors } from '../config/vendor';
import { s3DataPrefix } from '../config/app';
import fallbackDefaultTranslations from '../lp-data/translations/en-GB.json';
import { HookState } from '../types/hooks';

/**
 * Fetch translation s3 file
 * @return {{data: Object|null, loading: boolean, error: boolean}}
 */
const useTranslations = (): HookState => {
    const [status, setStatus] = useState({
        loading: true,
        error: false,
        data: fallbackDefaultTranslations,
    });

    const vendor = useVendor();

    useEffect(() => {
        (async () => {
            // Declaring these variables inside try{...} statement
            // Otherwise this leads to a babel compilation error when running Jest tests
            let response, translations;

            try {
                response = await fetch(`/${s3DataPrefix}/translations/${vendors[vendor].locale}.json`);
                if (!response.ok) {
                    throw new Error(`${response.status} ${response.statusText}`);
                }

                translations = await response.json();
                setStatus({ loading: false, error: false, data: translations });
            } catch (error: any) {
                console.error(`Translation file error: ${error.message}`);
                setStatus({ loading: false, error: true, data: fallbackDefaultTranslations });
            }
        })();
    }, [vendor]);

    return status;
};

export default useTranslations;
